<!-- email-template.component.html -->
<div class="main-layout">
    <div class="right-container">
      <div class="title">
        <div class="back-button" (click)="backbutton()">
          &larr;
        </div>
        {{ isEditMode ? 'Edit Email template ' : 'Create email template' }}
      </div>
  
      <div class="container">
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
          <div class="top-block">
            <div class="cust row-1">
              <label class="labels" for="template_name">Template name*</label>
              <input class="input-box" type="text" id="template_name" formControlName="template_name" placeholder="Enter Template name">
            </div>
  
            <div class="row-2">
              <div class="cust">
                <label class="labels" for="subject">Subject line*</label>
                <input class="input-box" type="text" id="subject" formControlName="subject" placeholder="Enter Subject line">
              </div>
            </div>
  
            <div class="row3">
              <div class="cust">
                <label class="labels" for="body">Email body*</label>
                <textarea class="input-box" id="body" formControlName="body" placeholder="Enter Email body" rows="12"></textarea>
              </div>
            </div>
          </div>
  
          <div class="buttons-container">
            <!-- First line of buttons: Cancel and Create -->
            <div class="button-line">
              <button type="button" class="action-button cancel-button" (click)="cancel()" *ngIf="!isEditMode">Reset</button>
              <button type="submit" class="action-button create-button" *ngIf="!isEditMode">Create</button>
            </div>
  
            <!-- Second line of buttons: Edit, Delete, and Save -->
            <div class="button-line">
              <button type="button" class="action-button edit-button" *ngIf="isEditMode"  (click)="onEditEnable()">Edit</button>
              <!-- <button type="button" class="action-button delete-button"*ngIf="isEditMode" (click)="deleteProfile()">Delete</button> -->
              <button 
              type="button" 
              class="action-button save-button" 
              *ngIf="isEditMode" 
              [disabled]="isButtonDisabled" 
              [ngClass]="{'disabled': isButtonDisabled}" 
              (click)="onEdit()"
            >
              Save
            </button>            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  